import React, { createContext, useContext, useEffect, useState, FC } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import jsCookie from 'js-cookie';
import { getUser } from 'logic/store/authentication/actions';
import { isSummaryTotalsAvailable as isSummaryTotalsAvailableService } from 'api/balanceTransaction/service';

const BankConfigContext = createContext({});

export const BankConfigProvider: FC = ({ children, ...props }) => {
  const [config, setConfig] = useState({});
  const authenticationId = useSelector((state) => state.auth?.user?.authenticationId);

  useEffect(() => {
    let subscription;

    if (authenticationId) {
      subscription = isSummaryTotalsAvailableService().subscribe(
        ({ data: { isSummaryTotalsAvailable } }) => {
          setConfig({
            ...config,
            isSummaryTotalsAvailable
          });
        },
        () => {
          setConfig({
            ...config,
            isSummaryTotalsAvailable: true
          });
        }
      );
    }

    return () => subscription?.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticationId]);

  return (
    <BankConfigContext.Provider value={config}>
      {typeof children === 'function' ? children({ bankConfig: config, ...props }) : children}
    </BankConfigContext.Provider>
  );
};

BankConfigProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired
};

export const useBankConfig = () => useContext(BankConfigContext);

export default BankConfigProvider;
